<div class="p-4">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div *ngIf="!isUpdateAll" class="card-sub-heading">
      Update the request status as {{helperService.stringConvertToTitleCase(props.item.RenewRefillStatusType)}}? </div>
    <div *ngIf="isUpdateAll" class="card-sub-heading">
      Update the request status
    </div>
    <button mat-icon-button (click)="dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
  <form [formGroup]="form" (ngSubmit)="!disableButton && formSubmit()">
    <div *ngIf="isUpdateAll" class="mb-2">
      <mat-form-field class="w-100">
        <mat-select formControlName="RenewRefillStatusType" (selectionChange)="renewRefillStatusChange()"
          [(value)]="RenewRefillStatusID" class="form-control matselect w-100" placeholder="Status">
          <mat-option *ngFor="let item of status" [value]="item.id">
            {{ item.type }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <app-error-message [formName]="form" [fieldName]="'RenewRefillStatusType'" [type]="'group'">
      </app-error-message>
    </div>
    <div class="row py-2">
      <div class="col-md-12"
        *ngIf="!(props?.item?.StatusType == 'renew_request' && ['waiting for patient', 'waiting for prescription', 'renewed'].includes(props?.item?.RenewRefillStatusType)|| ['7','8', '9'].includes(RenewRefillStatusID?.toString()))">
        <mat-checkbox class="example-margin bold" (change)="onCheckChange($event)" formControlName="NotifyUsers">
          Notify Users
        </mat-checkbox>
        <div class="row p-3" *ngIf="form.value.NotifyUsers">
          <div class="col-md-12">
            <div class="d-flex row pt-3">
              <ng-container formArrayName="NotifyUsersBy">
                <ng-container *ngFor="let item of notifyByArray.controls; let i = index">
                  <ng-container [formGroupName]="i">
                    <div class="col-md-4">
                      <mat-checkbox value="{{ item.value.id }}" formControlName="isChecked"
                        [disabled]="item.value.disable">{{ item.value.value }}
                      </mat-checkbox>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <app-error-message [formName]="form" [fieldName]="'NotifyUsersBy'" [type]="'group'">
              </app-error-message>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- reject dropdown -->
    <ng-container *ngIf="!isReasonLoaded && (RenewRefillStatusID == '4' || RenewRefillStatusID == '14')">
      <div class="d-flex align-items-center justify-content-center">
        <span class="whiteLoader" style="width: 30px; height: 30px;"></span>
      </div>
    </ng-container>
    <ng-container *ngIf="isReasonLoaded">
      <div *ngIf="RenewRefillStatusID == '4' || RenewRefillStatusID == '14'" class="mb-2">
        <mat-form-field class="w-100">
          <mat-select formControlName="RejectedReasonID" class="form-control matselect w-100"
            placeholder="Select Reason To Cancelled" (selectionChange)="RejectedReasonIDChange($event.value)">
            <mat-option *ngFor="let item of rejectedReason" [value]="item.id">
              {{ item.reason }}
            </mat-option>
            <!-- <mat-option class="select-btn" (click)="openAddRasonDialog()">
            <div class="d-flex align-items-center">
              <span class="material-icons mr-2 add"> add </span> Add Reason To
              Cancelled
            </div>
          </mat-option> -->
          </mat-select>
        </mat-form-field>
        <app-error-message [formName]="form" [fieldName]="'RejectedReasonID'" [type]="'group'">
        </app-error-message>
      </div>

      <div class="row mb-2">
        <div class="col-md-12" *ngIf="showInternalNotes">
          <label for="reasonList">Notes</label>
          <textarea class="form-control height" formControlName="internal_notes"
            placeholder="Please enter notes for selected reason" rows="3"></textarea>
        </div>
      </div>
    </ng-container>
    <!-- <div class="row py-2">
      <div class="col-md-12">
        <div class="card-sub-heading grey">User Last Login</div>
        <div class="mt-2">Mon, Aug 16, 2021 6:27</div>
      </div>
    </div> -->
    <ng-container *ngIf="!isMessageLoaded && form.get('message')?.value != null">
      <div class="d-flex align-items-center justify-content-center">
        <span class="whiteLoader" style="width: 30px; height: 30px;"></span>
      </div>
    </ng-container>
    <ng-container
      *ngIf="form.get('message')?.value != null && !(props?.item?.StatusType == 'renew_request' && ['waiting for patient', 'waiting for prescription', 'renewed'].includes(props?.item?.RenewRefillStatusType)|| ['7','8', '9'].includes(RenewRefillStatusID?.toString()))">
      <!-- <div class="row py-4">
        <div class="col-md-12">
          <mat-checkbox class="example-margin" formControlName="custom_message">Custom Message</mat-checkbox>
        </div> -->
      <ng-container *ngIf="isMessageLoaded && form.get('message')?.value != null && isPatientMessage">
        <div class="row py-4">
          <div class="col-md-12">
            <mat-checkbox class="example-margin" formControlName="custom_message">Automated chat</mat-checkbox>
          </div>
        </div>
        <div class="row" *ngIf="form.get('custom_message')?.value == true">
          <div class="col-md-12" *ngIf="tenant == 'pl' || 'sl' ">
            <div class="form-group">
              <textarea class="form-control height" formControlName="message"
                placeholder="We have Confirm your prescription. If you have any questions, please call/ text 1833 Pillway or download the pillway app. click here to download the app: http://pillway.page.link/jhj1"
                rows="3"></textarea>
              <app-error-message [formName]="form" [fieldName]="'message'" [type]="'group'">
              </app-error-message>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- </div> -->
    </ng-container>
    <div class="row mt-4">
      <div class="col-md-12 d-flex align-items-end justify-content-end">
        <button class="custom-btn" (click)="dialogRef.close()" type="button">
          Cancel
        </button>
        <button class="custom-btn" [disabled]="disableButton" type="submit">
          Confirm
          <span class="whiteLoader" *ngIf="isLoading"></span>
        </button>
      </div>
    </div>
  </form>
</div>
